import {createAsyncThunk} from '@reduxjs/toolkit'
import {toast as message} from 'react-toastify'
import {getApi, patchApi, postApi} from '../../../axios'
import {API_ERROR} from '../../../global'
import { APPSETTING } from '../../../axios/services'






export const createappsetting = createAsyncThunk(
  'app/createappsetting',
  async ({body, next = () => {}}, thunkAPI) => {
    try {
      const response = await postApi(APPSETTING, body)
      if (response?.data?.success) {
        message.success(response?.data?.message)
        return response?.data
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR)
      return thunkAPI.rejectWithValue(error.response.data.message)
    }
  }
)



export const patchAppsetting = createAsyncThunk(
  'app/patchAppsetting',
  async ({body, next = () => {}}, thunkAPI) => {
    try {
      const response = await patchApi(APPSETTING, body)
      if (response?.data?.success) {
        message.success(response?.data?.message)
        return response?.data
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR)
      return thunkAPI.rejectWithValue(error.response.data.message)
    }
  }
)





export const getAppsetting = createAsyncThunk(
    'app/getAppsetting',
    async (_, thunkAPI) => {
      try {
        const response = await getApi(`${APPSETTING}`) 
        if (response?.data?.success) {
            console.log(response?.data?.data,'response?.dataresponse?.data')  
          return response?.data?.data
        }
      } catch (error) {
        message.error(error?.response?.data?.message || API_ERROR)
        return thunkAPI.rejectWithValue(error.response.data.message)
      }
    })